import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import { DeleteOutlineRounded } from "@mui/icons-material";
import { DataTableColumn, TagChip } from "../../../components/ui";
import { DcoModel } from "./table/dco.model";

type Options = {
    onDelete: (id: number) => void;
};

/** Colunas da tabela de e-mails DCO (E-mail / Plano / Tag / Ações). */
export function buildDcoColumns({ onDelete }: Options): DataTableColumn<DcoModel>[] {
    return [
        {
            key: "email",
            header: "E-mail",
            width: "2.5fr",
            render: (row) => (
                <Typography sx={{ fontSize: "13.5px", fontWeight: 500, color: "text.primary" }}>{row.email}</Typography>
            ),
        },
        {
            key: "plan",
            header: "Plano",
            width: "1fr",
            render: (row) => <Typography sx={{ fontSize: "13.5px", color: "text.primary" }}>{row.plan || "—"}</Typography>,
        },
        {
            key: "tag",
            header: "Tag",
            width: "1fr",
            render: (row) =>
                row.tag ? <TagChip label={row.tag} /> : <Typography sx={{ fontSize: "13px", color: "text.disabled" }}>—</Typography>,
        },
        {
            key: "actions",
            header: "Ações",
            width: "80px",
            align: "right",
            render: (row) => (
                <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                    <Tooltip title="Remover e-mail" placement="top">
                        <IconButton
                            size="small"
                            color="error"
                            onClick={(e) => {
                                e.stopPropagation();
                                onDelete(row.id);
                            }}
                            aria-label="Remover e-mail"
                            sx={{ borderRadius: "9px" }}
                        >
                            <DeleteOutlineRounded sx={{ fontSize: 16 }} />
                        </IconButton>
                    </Tooltip>
                </Box>
            ),
        },
    ];
}
